/**
 * Utilities specific to WICPA
 */

/**
 * Dependencies
 */
import isExternalURL, {isAssetURL} from '../../vendor/imarc/inkwell/resources/scripts/modules/linkObserver';

window.addEventListener('content-populated', () => {
    const anchors = document.querySelectorAll('a');

    if (anchors.length) {
        anchors.forEach(anchor => {
            if (isExternalURL(anchor) || isAssetURL(anchor)) {
                anchor.classList.add('js-external');
            }
        });
    }
});
